export default __webpack_public_path__ + "static/media/Round@1x.fe7ba074.png";